var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert3 = function SvgAlert3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 160 161"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 130.061,
    fill: "#ACADAD",
    rx: 80,
    ry: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F55E36",
    d: "M138.054 112.445 92.44 33.477c-5.529-9.555-19.351-9.555-24.88 0l-45.614 78.968c-5.529 9.556 1.382 21.575 12.44 21.575h91.228c11.058 0 17.969-12.019 12.44-21.575z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M75.674 55.773h8.714c1.563 0 2.825 1.503 2.705 3.185l-3.005 33.234c-.06.902-.781 1.623-1.623 1.623h-4.688c-.84 0-1.562-.721-1.622-1.623L72.97 59.02c-.12-1.743 1.082-3.246 2.704-3.246zm4.387 61.24c-3.846 0-7.031-3.125-7.031-7.032 0-3.846 3.185-7.031 7.031-7.031 3.906 0 7.032 3.185 7.032 7.031a7.002 7.002 0 0 1-7.032 7.032z"
  })));
};
export { SvgAlert3 as ReactComponent };
export default __webpack_public_path__ + "assets/alert-3.svg";